<template>
  <v-footer class="footer-container" color="#06142D">
    <!-- Desktop Layout -->
    <div class="d-none d-md-block footer-desktop">
      <!-- Top row with logo and navigation links -->
      <v-row no-gutters class="footer-top-row px-4 px-sm-8 px-md-16 py-4">
        <v-col cols="auto" class="footer-logo mb-8">
          <h1>Visitor 360</h1>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="footer-nav d-flex align-center">
          <a href="https://www.nhb.gov.sg/contact-us" class="footer-link" target="_top">
            Contact
          </a>
          <a href="https://www.nhb.gov.sg/feedback" class="footer-link" target="_top">
            Feedback
          </a>
          <a href="https://www.reach.gov.sg/" class="footer-link d-flex align-center" target="_blank" rel="noopener noreferrer">
            <span>Reach.gov.sg</span>
            <v-icon small color="white" class="ml-1">{{ mdiOpenInNew }}</v-icon>
          </a>
        </v-col>
      </v-row>
      
      <!-- Separator line -->
        <div class="footer-divider mb-5 px-3 px-sm-8 px-md-16"></div>
      
      <!-- Bottom row with links and copyright -->
      <v-row no-gutters class="footer-bottom-row px-4 px-sm-8 px-md-16 py-2">
        <v-col cols="auto" class="footer-bottom-links d-flex align-center">
          <a href="https://www.tech.gov.sg/report_vulnerability" class="footer-link-small d-flex align-center" target="_blank" rel="noopener noreferrer">
            <span>Report Vulnerability</span>
            <v-icon small color="white" class="ml-1">{{ mdiOpenInNew }}</v-icon>
          </a>
          <a href="https://www.nhb.gov.sg/contents/privacy-policy" class="footer-link-small" target="_top">
            Privacy Statement
          </a>
          <a href="https://www.nhb.gov.sg/contents/terms-of-use" class="footer-link-small" target="_top">
            Terms of use
          </a>
        </v-col>
      </v-row>
      <v-row no-gutters class="footer-bottom-row px-4 px-sm-8 px-md-16 py-2">
        <v-spacer></v-spacer>
        <v-col cols="auto" class="footer-copyright d-flex flex-column align-end">
          <div class="copyright-text">&copy; 2025 Government of Singapore</div>
          <div class="updated-text">Last Updated 11 Aug 2025</div>
        </v-col>
      </v-row>
    </div>

    <!-- Mobile/Tablet Layout -->
    <div class="d-block d-md-none footer-mobile">
      <div class="footer-mobile-content px-2 py-8">
        <!-- Logo left aligned -->
        <div class="footer-logo-mobile mb-8">
          <h1>Visitor 360</h1>
        </div>
        
        <!-- Navigation links centered with separators -->
        <div class="footer-nav-mobile text-right mb-6">
          <a href="https://www.nhb.gov.sg/contact-us" class="footer-link-mobile" target="_top">
            Contact
          </a>
          <span class="footer-separator">&bull;</span>
          <a href="https://www.nhb.gov.sg/feedback" class="footer-link-mobile" target="_top">
            Feedback
          </a>
          <span class="footer-separator">&bull;</span>
          <a href="https://www.reach.gov.sg/" class="footer-link-mobile d-inline-flex align-center" target="_blank" rel="noopener noreferrer">
            <span>Reach.gov.sg</span>
            <v-icon small color="white" class="ml-1">{{ mdiOpenInNew }}</v-icon>
          </a>
        </div>
        
        <!-- Separator line -->
        <div class="footer-divider mb-6"></div>
        
        <!-- Bottom links centered with separators -->
        <div class="footer-bottom-mobile text-left mb-6">
          <a href="https://www.tech.gov.sg/report_vulnerability" class="footer-link-mobile d-inline-flex align-center" target="_blank" rel="noopener noreferrer">
            <span>Report Vulnerability</span>
            <v-icon small color="white" class="ml-1">{{ mdiOpenInNew }}</v-icon>
          </a>
          <span class="footer-separator">&bull;</span>
          <a href="https://www.nhb.gov.sg/contents/privacy-policy" class="footer-link-mobile" target="_top">
            Privacy Statement
          </a>
          <span class="footer-separator">&bull;</span>
          <a href="https://www.nhb.gov.sg/contents/terms-of-use" class="footer-link-mobile" target="_top">
            Terms of use
          </a>
        </div>
        
        <!-- Copyright centered -->
        <div class="footer-copyright-mobile text-right">
          <div class="copyright-text-mobile">&copy; 2025 Government of Singapore</div>
          <div class="updated-text-mobile">Last Updated 12 Feb 2025</div>
        </div>
      </div>
    </div>
  </v-footer>
</template>
<script lang="ts">
import Vue from 'vue'
import Options from 'vue-class-component'
import { mdiOpenInNew } from '@mdi/js'

@Options({})
export default class AppFooter extends Vue{
  mdiOpenInNew = mdiOpenInNew
}
</script>

<style scoped>
.footer-container {
  z-index: 100;
  width: 100%;
  position: relative !important;
  margin-top: 0 !important;
}

/* Desktop Styles */
.footer-desktop {
  width: 100%;
}

.footer-logo h1 {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.footer-link {
  color: white;
  text-decoration: none;
  font-size: 16px;
  margin-left: 24px;
}

.footer-link:hover {
  color: #ccc;
  text-decoration: none;
}

.footer-link-small {
  color: white;
  text-decoration: none;
  font-size: 14px;
  margin-right: 24px;
}

.footer-link-small:hover {
  color: #ccc;
  text-decoration: none;
}

.footer-copyright {
  text-align: right;
}

.copyright-text, .updated-text {
  color: white;
  font-size: 14px;
  line-height: 1.4;
}

.updated-text {
  opacity: 0.8;
}

/* Mobile Styles */
.footer-mobile {
  width: 100%;
}

.footer-mobile-content {
  max-width: 100%;
}

.footer-logo-mobile {
  text-align: left;
}

.footer-logo-mobile h1 {
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

.footer-link-mobile {
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: 400;
}

.footer-link-mobile:hover {
  color: #ccc;
  text-decoration: none;
}

.footer-separator {
  color: white;
  margin: 0 16px;
  opacity: 0.8;
  font-size: 16px;
}

.footer-divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  width: 100%;
  margin: 0;
}

.copyright-text-mobile, .updated-text-mobile {
  color: white;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 400;
}

.updated-text-mobile {
  opacity: 0.9;
  margin-top: 8px;
}

/* Responsive adjustments for small mobile */
@media screen and (max-width: 576px) {
  .footer-mobile-content {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  
  .footer-logo-mobile h1 {
    font-size: 20px;
  }
  
  .footer-link-mobile {
    font-size: 10px;
  }
  
  .footer-separator {
    margin: 0 12px;
    font-size: 14px;
  }
  
  .copyright-text-mobile, .updated-text-mobile {
    font-size: 12px;
  }
}

/* Very small devices */
@media screen and (max-width: 360px) {
  .footer-logo-mobile h1 {
    font-size: 20px;
  }
  
  .footer-link-mobile {
    font-size: 12px;
  }
  
  .footer-separator {
    margin: 0 8px;
    font-size: 12px;
  }
  
  .copyright-text-mobile, .updated-text-mobile {
    font-size: 11px;
  }
}

/* Tablet adjustments */
@media screen and (min-width: 577px) and (max-width: 991px) {
  .footer-mobile-content {
    max-width: 700px;
    margin: 0 auto;
    padding: 3rem 2rem;
  }
}
</style>